import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";


export class AgGridSquirrelEnvironmentSettings {

    constructor(private translate: TranslateService) {}

    public agGridSquirrelEnvironmentSettings = {
        rowModelType: 'infinite',
        //virtualPaging: true,
        //enableServerSideSorting: true,
        //enableServerSideFilter: true,
        rowSelection: 'single',
        //rowDeselection: true,
        rowHeight: 45,
        enableRangeSelection: true,
        cacheBlockSize: 10000,
        cacheOverflowSize: 2,
        maxConcurrentDatasourceRequests: 1,
        paginationPageSize: 30,
        infiniteInitialRowCount: 0,
        columnDefs: [
          { field: 'name', headerName: `Name`, sortable: true, filter: true },
          { field: 'url', headerName: `Url`, sortable: true, filter: true },
          // { field: 'numberOfMigrations', headerName: `Number Of Migrations`, sortable: true, filter: true },
          // { field: 'migratedWhen', headerName: `Migration Date`, sortable: true, filter: true },
          {
            headerName: `Actions`,
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              icon_edit: 'edit',
              icon_delete: 'delete'
            },
          },
        ],
        defaultColDef: {
          flex: 1,
          resizable: true,
          minWidth: 100,
          editable: false
        }
      }
}